export default __webpack_public_path__ + "static/media/roller.1cf26e42.png";